import React from 'react';
import { XIcon } from 'lucide-react';
import { Button } from './Button';
export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-238">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-239">
        <div className="fixed inset-0 bg-black bg-opacity-30" onClick={onClose} data-id="element-240" />

        <div className="relative bg-white rounded-lg shadow-xl max-w-lg w-full" data-id="element-241">
          <div className="flex items-center justify-between p-4 border-b" data-id="element-242">
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-243">{title}</h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-244">
              <XIcon className="w-5 h-5" data-id="element-245" />
            </button>
          </div>

          <div className="p-4" data-id="element-246">{children}</div>

          {footer && <div className="flex justify-end gap-2 p-4 border-t bg-gray-50" data-id="element-247">
              {footer}
            </div>}
        </div>
      </div>
    </div>;
}